module.exports = {"collapseAll":"Collapse All","expandAll":"Expand All","backToPrevious":"Back to Previous","getMenuFailed":"Failed to get menu","noMenuPermission":"Current agent has no menu permission"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en-US/menu.json
// module id = Rl0G
// module chunks = 1